/*
 *   This is a service for a specific store module which uses the api.ts Axios instance as a base.
 *   We separate our files for easy managment and readibility.
 *   We export this as a service to be used in other areas of the application.
 */

import Api from '@/services/api';
import AppService from '@/services/app';
import Store from '@/store/index';

export default { 

  resetActive() {
    // reset store to empty
    Store.dispatch('drivers/setActiveDrivers', {
      drivers: [],
    });
  }, 

  async listActive(refreshFromAPI: boolean) {
    // check if we need to force an API refresh or have already fetched this data and it is in the Store
    if (refreshFromAPI || Store.getters['drivers/activeDrivers'].length < 1) {
      try {
        const response = await Api(true).get('/driver/list_active');
        
        if (response && response.data) {
          if (response.data.result && response.data.result === 'false') {
            this.resetActive();
            return response.data.message;
          } else {
            Store.dispatch('drivers/setActiveDrivers', {
              drivers: response.data,
            });
            return '';
          }
        } else {
          // response is undefined or has no data field - SHOULD NEVER HAPPEN!
          throw new Error('response: ' + JSON.stringify(response));
        }

      } catch (error) {
        this.resetActive();
        if (error.response) {
          return error.response.statusText;
        } else {
          AppService.logSupportDebug('drivers.ts - listActive - 46 - ' + error);
          return Store.getters['app/messages'].couldNotConnect;
        }
      } 
    } else {
      // this data is ready to access in the Store
      return '';
    }
  },

  resetAvailable() {
    // reset store to empty
    Store.dispatch('drivers/setAvailableDrivers', {
      availableDrivers: [],
    });
  }, 

  async listAvailable(refreshFromAPI: boolean) {
    // check if we need to force an API refresh or have already fetched this data and it is in the Store
    if (refreshFromAPI || Store.getters['drivers/availableDrivers'].length < 1) {
      try {
        const response = await Api(true).get('/driver/list_available');
        
        if (response && response.data) {
          if (response.data.result && response.data.result === 'false') {
            this.resetAvailable();
            return response.data.message;
          } else {
            Store.dispatch('drivers/setAvailableDrivers', {
              availableDrivers: response.data,
            });
            return '';
          }
        } else {
          // response is undefined or has no data field - SHOULD NEVER HAPPEN!
          throw new Error('response: ' + JSON.stringify(response));
        }

      } catch (error) {
        this.resetAvailable();
        if (error.response) {
          return error.response.statusText;
        } else {
          AppService.logSupportDebug('drivers.ts - listAvailable - 89 - ' + error);
          return Store.getters['app/messages'].couldNotConnect;
        }
      } 
    } else {
      // this data is ready to access in the Store
      return '';
    }
  },

  resetDeleted() {
    // reset store to empty
    Store.dispatch('drivers/setDeletedDrivers', {
      drivers: [],
    });
  }, 

  async listDeleted(refreshFromAPI: boolean) {
    // check if we need to force an API refresh or have already fetched this data and it is in the Store
    if (refreshFromAPI || Store.getters['drivers/deletedDrivers'].length < 1) {
      try {
        const response = await Api(true).get('/driver/list_deleted');
        
        if (response && response.data) {
          if (response.data.result && response.data.result === 'false') {
            this.resetDeleted();
            return response.data.message;
          } else {
            Store.dispatch('drivers/setDeletedDrivers', {
              drivers: response.data,
            });
            return '';
          }
        } else {
          // response is undefined or has no data field - SHOULD NEVER HAPPEN!
          throw new Error('response: ' + JSON.stringify(response));
        }

      } catch (error) {
        this.resetDeleted();
        if (error.response) {
          return error.response.statusText;
        } else {
          AppService.logSupportDebug('drivers.ts - listDeleted - 132 - ' + error);
          return Store.getters['app/messages'].couldNotConnect;
        }
      } 
    } else {
      // this data is ready to access in the Store
      return '';
    }
  },

  create(params: {
    typeId: number,
    linkBonus: boolean,
    name: string,
    nickname: string,
    idNumber: string,
    cellNumber: string,
    cellNumber2?: string,
    pdpExpiry: string,
    hasReceipt: boolean,
    startDate?: string,
    trainingDate?: string,
  }) {
    return Api(true).post('/driver/create', params);
  },

  update(params: {
    id: number,
    typeId: number,
    linkBonus: boolean,
    name: string,
    nickname: string,
    idNumber: string,
    cellNumber: string,
    cellNumber2?: string,
    pdpExpiry: string,
    hasReceipt: boolean,
    startDate?: string,
    trainingDate?: string,
  }) {
    return Api(true).post('/driver/update', params);
  },

  delete(params: {
    id: number,
  }) {
    return Api(true).post('/driver/delete', params);
  },

  restore(params: {
    id: number,
  }) {
    return Api(true).post('/driver/restore', params);
  },

};
